import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    
    <footer>
      <div className="footer_container">
        <div className="footer_content">
          <h2>Rahul Antony</h2>
          <p>© 2023 Rahul Antony. All rights reserved.</p>
        </div>
      </div>
    </footer>

  )
}

export default Footer